// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__BIxKG","header__content":"styles_header__content__6Yc_U"};